module.exports = __webpack_public_path__ + "img/657.3ab0814a.jpg";